<template>
    <div class="appImage">
        <el-image
            style="width: 100%; height: 100%"
            :src="isBase64? `data:image/png;base64,${src}` : `${api}${src}`"
            :preview-src-list="[isBase64? `data:image/png;base64,${src}` : `${api}${src}`]"
            :preview-teleported="true"
            :z-index="999999">
          <template #error>
              <div class="error">{{ errorText }}</div>
          </template>
        </el-image>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        src: String,
        isBase64:{
          type: Boolean,
          default: false
        },
        errorText:{
          type: String,
          default: '加载失败'
        },
    },
    data() {
        return {
            api: process.env.VUE_APP_IMG_URL,
        };
    },
    mounted() {

    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.appImage {
    width: 80px; height: 80px
}
.error{
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  font-size: 14px;
  color: #a8abb2;
  text-align: center;
  line-height: 80px;
}

</style>
